import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CustomMaterialModule } from '@common/material.module';

import { LoginComponent } from './login.component';
import { LoginMotivateXRComponent } from './external-login/login-motivateXR.component';
import { LoginTecnaliaComponent } from './external-login/login-tecnalia.component';
import { CredentialsService } from './credentials.service';

@NgModule({ declarations: [LoginComponent, LoginMotivateXRComponent, LoginTecnaliaComponent],
    exports: [LoginComponent, LoginMotivateXRComponent, LoginTecnaliaComponent], imports: [CommonModule,
        FormsModule,
        CustomMaterialModule,
        TranslateModule.forChild({
            extend: true
        })], providers: [CredentialsService] })
export class CredentialsModule { }
